import React from 'react';
import { PageTitle } from '../../../../rbts/layout/core';
import { Vista } from './components/Vista';

const VentasCortesiasTipoPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Reporte de Ventas con Cortesías por Tipo</PageTitle>
      <Vista />
    </>
  );
};

export { VentasCortesiasTipoPage };
